/**
 * This is a proxy for route navigation based on click event
 * It will open a new tab if user clicks with meta key pressed
 * @param event
 * @param location
 */
import { isCtrlEvent } from '@/utils/kbEvents'

export default function(event, location, openInNewTab) {
  if (isCtrlEvent(event) || openInNewTab) {
    const route = this.$router.resolve(location)
    window.open(route.href, '_blank')
  } else {
    this.$router.push(location)
  }
}
